const tableauSearch = ((jQuery) => {
    'use strict';

    const placeholderDiv = document.getElementById("tableauViz");

    if (placeholderDiv === null) {
        return;
    }

    const section = jQuery('#tableauViz').attr('data-section');
    const filters = jQuery('.insights-filter');
    const productsFilter = jQuery('#ref_id_produit');
    const filtersLoader = jQuery('#filter-loader');
    const searchBtn = jQuery('#search');
    const searchBtnLoader = searchBtn.find('#search-loader');
    const resetBtn = jQuery('#reset');
    const resetBtnLoader = resetBtn.find('#reset-loader');
    const storeFilter = jQuery('#enseigne');
    const placeholder = 'Tout';
    const clearBtn = '<span id="clear-btn" onclick="clearRefSelection();">x</span>';
    let tags = [];

    const preloader = (btn, loader, state) => {
        if (state === 'show') {
            btn.attr('disabled', 'disabled');
            loader.prev('i').addClass('d-none');
            loader.removeClass('d-none');

            return state;
        }
        loader.addClass('d-none');
        loader.prev('i').removeClass('d-none');
        btn.removeAttr('disabled');

        return state;
    };

    const applyParameter = (name, value) => {
        workbook.changeParameterValueAsync(name, value);
    };

    const applyFilter = (name, value, all = false) => {
          activeSheet.applyFilterAsync(name, value, (all ? tableau.FilterUpdateType.ALL : tableau.FilterUpdateType.REPLACE));
    };

    const resumeUpdate = async () => await viz.resumeAutomaticUpdatesAsync().then(() => preloader(searchBtn, searchBtnLoader, 'hide'));

    const select2Lang = () => {
        return {
            errorLoading: () => 'Les résultats ne peuvent pas être chargés.',
            inputTooLong: (args) => {
                const overChars = args.input.length - args.maximum;
                return 'Supprimez ' + overChars + ' caractère' +
                    ((overChars > 1) ? 's' : '');
            },
            inputTooShort: (args) => {
                const remainingChars = args.minimum - args.input.length;
                return 'Saisissez au moins ' + remainingChars + ' caractère' +
                    ((remainingChars > 1) ? 's' : '');
            },
            loadingMore: () => 'Chargement...',
            maximumSelected: (args) => 'Vous pouvez seulement sélectionner ' + args.maximum +
                ' élément' + ((args.maximum > 1) ? 's' : ''),
            noResults: () => 'Aucun résultat trouvé',
            searching: () => 'Recherche en cours…',
            removeAllItems: () => 'Supprimer tous les éléments',
            removeItem: () => 'Supprimer l\'élément'
        };
    };

    const setRefRequestData = params => {
        return {
            section: section,
            search: params.term || '',
            page: params.page || 1,
            filters: [...document.querySelectorAll('.insights-filter')].map(filter => {
                return {
                    [filter.getAttribute('id')]: jQuery('#' + filter.getAttribute('id')).select2('data')[0].text
                };
            })
        };
    };

    const setRefCustomPlaceholder = () => {
        jQuery(`
            <div class="select2-selection__custom" data-toggle="tooltip" data-html="true">
                <span id="search-placeholder">${placeholder}</span>
            </div>
        `).appendTo(productsFilter.next().find('.select2-selection'));
    };

    const setRefTooltipContent = () => {
        const $tooltipSelector = jQuery('.select2-selection__custom');
        let tooltipContent = '';
        for (let i = 0; i < tags.length; i++) {
            tooltipContent += tags[i].value + '<br>';
        }
        $tooltipSelector
            .attr('title', '')
            .attr('data-original-title', tooltipContent)
            .tooltip({placement: 'top'});
    };

    const findObjectByKey = (array, key, value) => {
        for (let i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
        return null;
    };

    const setRefSelection = () => {
        const nbSelected = productsFilter.val().length;
        const value = nbSelected > 0
            ? nbSelected + ' référence' + (nbSelected > 1 ? 's' : '') + clearBtn
            : placeholder;

        productsFilter
            .next()
            .find('#search-placeholder')
            .html(value);
    };

    const syncSearchInput = () => {
        jQuery('.select2-search__field').on('input', function (){
            $('#search-placeholder').html($(this).val());
        });
    };

    const clearRefSelection = () => {
        const $tooltipSelector = jQuery('.select2-selection__custom');
        tags = [];
        productsFilter.val([]).change();
        setRefSelection();
        $tooltipSelector
            .attr('data-original-title', '')
            .attr('title', '')
            .tooltip('dispose');

        return false;
    };

    filters.select2({
        theme: 'bootstrap4',
        language: select2Lang(),
    });

    // Reference filter
    productsFilter.select2({
        theme: 'bootstrap4',
        dropdownAutoWidth: true,
        language: select2Lang(),
        allowClear: true,
        width: '100%',
        placeholder: placeholder,
        dropdownParent: jQuery('#search-parent'),
        ajax: {
            url: '/insights/references',
            dataType: 'json',
            cache: true,
            delay: 500,
            data: params => setRefRequestData(params),
            processResults: data => data,
        }
    }).on('select2:open', () => syncSearchInput())
      .on('select2:close', () => setRefSelection())
      .on('select2:select', function (e) {
        tags.push({
            value: e.params.data.text,
            select: jQuery(this).attr('data-select')
        });

        setRefSelection();
        setRefTooltipContent();

    }).on('select2:unselect', function (e) {
        const selected = {
            value: e.params.data.text,
            select: productsFilter.attr('data-select')
        };

        const foundObj = findObjectByKey(tags, 'value', selected.value);
        const indexToDelete = tags.indexOf(foundObj);
        tags.splice(indexToDelete, 1);

        setRefSelection();
        setRefTooltipContent();

        setTimeout(function () {
            jQuery('.select2-dropdown').parent().remove();
        }, 1);
    });

    setRefCustomPlaceholder();

    var marquechange = '';

  jQuery('#marque_full').on("change", function() {
    marquechange = 'ok';
  });

  jQuery('#id_marque').on("change", function() {
    marquechange = 'ok';
  });

  jQuery('#marque__full').on("change", function() {
    marquechange = 'ok';
  });

    // Update filters
  filters.on('select2:select', async function (e) {
    resetBtn.removeClass('d-none');
    filtersLoader.removeClass('d-none');

    const currentFilter = jQuery(this);
    const filters = [...document.querySelectorAll('.insights-filter')];

    // Clear child filters after changing parent filter
    let clearValues = false;
    filters.forEach(filter => {
      if (clearValues) {
        jQuery(filter).val('').trigger('change');
      }
      if (filter === currentFilter[0]) {
        clearValues = true;
      }
    });

    let values = filters.filter(function(test) {
      if (test.getAttribute('id') === "id_range" && marquechange == 'ok') {
        marquechange = '';
        return false; // skip
      }
      return true;
    }).map(f => {
      const data = jQuery('#' + f.getAttribute('id')).select2('data');
      return {
        'filter': f.getAttribute('id'),
        'value': data.length > 0 ? data[0].text : ''
      };
    });

    values = values.filter(v => v.value !== 'Tout');

    const response = await fetch('/insights/filters', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
      },
      body: JSON.stringify({
        'filters': values,
        'section': section
      })
    });

    const data = await response.json();
    for (const [key, value] of Object.entries(data)) {
      if (key === 'id_range') {
        values = value.map(v => (
          {
            id: v.id,
            text: v.name
          }
        ));
      } else {
        values = value.map(v => (
          {
            id: v,
            text: v
          }
        ));
      }

      if (key !== 'id_range') {
        jQuery('#' + key).select2('destroy').empty().select2({
          theme: 'bootstrap4',
          data: [
            {
              'id': '',
              'text': 'Tout',
            },
            ...values
          ],
        });
      } else {
        var groupedOptions = {};
        value.forEach(function(option) {
          // Create group if not exists
          if (!groupedOptions[option.category_product_range.name]) {
            groupedOptions[option.category_product_range.name] = [];
          }
          groupedOptions[option.category_product_range.name].push({
            id: option.id,
            text: option.name,
          });
        });

        var groupedData = Object.keys(groupedOptions).map(function(group) {
          return {
            text: group,
            children: groupedOptions[group],
          };
        });

        jQuery('#' + key).select2('destroy').empty().select2({
          theme: 'bootstrap4',
          data: [
            {
              id: '',
              text: 'Tout',
            },
            ...groupedData,
          ],
        });
      }
    }
    clearRefSelection();
    filtersLoader.addClass('d-none');
  });

    searchBtn.click(async e => {
      jQuery('#invalid-feedback').hide()
      e.preventDefault();
      preloader(searchBtn, searchBtnLoader, 'show');

      const viz = workbook.getViz();
      await viz.pauseAutomaticUpdatesAsync();

      // Filters
      const filters = [...document.querySelectorAll('.insights-filter, #ref_id_produit')];

      let ref = '';
      let range = '';

      let values = filters.map(filter => {
        const data = jQuery('#' + filter.getAttribute('id')).select2('data');
        let value;
        if (filter.getAttribute('id') === 'ref_id_produit') {
          ref = data.map(d => d.text);
          value = data.map(d => d.text);
        } else {
          if (filter.getAttribute('id') === 'id_range') {
            range = data[0].id;
            value = data[0].id;
          } else {
            value = data[0].text;
          }
        }

        return {
          filter: filter.dataset.field,
          type: filter.dataset.type ?? 'filter',
          value: value,
        };
      });

      let product = '';
      let errorWithRange = 0;
      if (range != '' && ref.length == 0) {
        const response = await fetch('/insights/getRefByRange', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
          },
          body: JSON.stringify({
            'filters': values.filter(f => f.value !== ''),
            'section': section,
          })
        });

        product = await response.json();
        if (product.length > 0) {
          values = filters.map(filter => {
            const data = jQuery('#' + filter.getAttribute('id')).select2('data');
            let value;
            if (filter.getAttribute('id') === 'ref_id_produit') {
              value = product;
            } else {
              if (filter.getAttribute('id') === 'id_range') {
                value = data[0].id;
              } else {
                value = data[0].text;
              }
            }
            return {
              filter: filter.dataset.field,
              type: filter.dataset.type ?? 'filter',
              value: value,
            };
          });
        } else {
          errorWithRange = 1;
        }
      }

      values = values.map(v => {
        if (v.value === 'Tout') {
          return {...v, value: ''}
        } else {
          return v;
        }
      });

      let dates_filters = [];

      // Parameters Dates
      if (document.getElementById('date1-start')) {
        const date1_start = document.getElementById('date1-start');
        const date1_end = document.getElementById('date1-end');
        const date2_start = document.getElementById('date2-start');
        const date2_end = document.getElementById('date2-end');

        dates_filters = {
          'P1 Date 1': date1_start.value,
          'P1 Date 2': date1_end.value,
          'P2 Date 1': date2_start.value,
          'P2 Date 2': date2_end.value
        }

        await applyParameter('P1 Date 1', date1_start.value);
        await applyParameter('P1 Date 2', date1_end.value);
        await applyParameter('P2 Date 1', date2_start.value);
        await applyParameter('P2 Date 2', date2_end.value);
      }

      await fetch('/insights/saveFilters', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
        },
        body: JSON.stringify({
          'filters': values.filter(f => f.value !== ''),
          'section': section,
          'dates': dates_filters
        })
      });

      if (errorWithRange === 0) {
        values.forEach(async v => {
          if (v.type === 'parameter') {
            await applyParameter(v.filter, v.value);
          } else {
            await applyFilter(v.filter, v.value, v.value === '' || v.value.length === 0);
          }
        });
        await resumeUpdate();
    } else {
        var myElement = document.getElementById('invalid-feedback');
        myElement.style.display = 'flex';
        preloader(searchBtn, searchBtnLoader, 'hide');
      }
        saveFiltersInLocalforage(values, dates_filters);
    });

    resetBtn.click(async e => {

        preloader(resetBtn, resetBtnLoader, 'show');

        e.preventDefault();

        await fetch('/insights/saveFilters', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
            },
            body: JSON.stringify({
                'filters': [],
                'section': section,
                'dates': []
            })
        });

        // Reset dates
        if (document.getElementById('date1-start')) {
            document.getElementById('date1-start').value = document.getElementById('date1-start').dataset.default;
            document.getElementById('date1-end').value = document.getElementById('date1-end').dataset.default;
            document.getElementById('date2-start').value = document.getElementById('date2-start').dataset.default;
            document.getElementById('date2-end').value = document.getElementById('date2-end').dataset.default;
        }

        // Reset Enseigne
        storeFilter.val('DARTY');
        storeFilter.trigger('change')

        // Reset products
        clearRefSelection();

        // Reset Filters
        const filters = [...document.querySelectorAll('.insights-filter:not(#enseigne)')];

        filters.forEach(f => {
            const el = jQuery('#' + f.getAttribute('id'));
            el.val('');
            el.trigger('change')
        })

        viz.revertAllAsync().then(() => {
            preloader(resetBtn, resetBtnLoader, 'hide');
            resetBtn.addClass('d-none');
        });

        resetFiltersInLocalforage();
    });

    const datesFilters = [...document.querySelectorAll('[id^="date"]')];

    datesFilters.forEach(filter => {
        filter.addEventListener('change', () => {
            resetBtn.removeClass('d-none');
        });
    });

    window.addEventListener('DOMContentLoaded', async function () {

        const response = await fetch('/insights/retrieve-filters', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
            },
            body: JSON.stringify({
                'section': section,
            })
        });

        const data = await response.json();

        if (Object.entries(data)) {

            // Set front filters from session

            resetBtn.removeClass('d-none');

            for (const [key, value] of Object.entries(data)) {

                if (['Ref Id Produit', 'reference', 'ref_id_produit'].includes(key)) {
                    value.forEach(val => {
                        const option = new Option(val, val, true, true);
                        productsFilter.append(option).trigger('change');
                        tags.push({
                            value: val,
                            select: jQuery(option).attr('data-select')
                        });
                        setRefSelection();
                        setRefTooltipContent();
                    });
                } else {
                    const filter = jQuery('[data-field="' + key + '"]')

                    if (key.startsWith('date')) {
                        filter.val(value);
                    } else {
                        filter.val(value);
                        filter.trigger('change')
                    }
                }
            }

            document.getElementById('tableauViz').dataset.options = JSON.stringify(data);
        }
    });

    const saveFiltersInLocalforage = (filtersValues, filtersDates) => {
        localforage.getItem('filters', (err, localforageValues) => {
            window.dashboardFiltersStorage = {
                ...localforageValues,
                ...filtersDates
            };
        }).then(() => {
            filtersValues.forEach(val => {
                window.dashboardFiltersStorage[val.filter] = val.value === '' ? 'all' : val.value;
            });
            localforage.setItem('filters', convertDates(dashboardFiltersStorage));
        });
    };

    const resetFiltersInLocalforage = () => {
        window.dashboardFiltersStorage = {
            'username': '',
            'workbook': {
                'name': window.workbook.getName(),
                'url': window.activeSheet.getUrl(),
                'sheet': window.activeSheet.getName()
            },
        };
        workbook.getParametersAsync().then(parameters => {
            parameters.forEach(parameter => {
                window.dashboardFiltersStorage[parameter.getName()] = parameter.getCurrentValue().formattedValue;
            });
            localforage.setItem('filters', convertDates(window.dashboardFiltersStorage));
        });
    };

    window.clearRefSelection = clearRefSelection;

})(jQuery);
